<script lang="ts">
  import type { DataTableRow } from 'carbon-components-svelte/src/DataTable/DataTable.svelte';

  import { InlineNotification } from 'carbon-components-svelte';

  import Table from '../../../../components/table/Table.svelte';
  import type { TableColumn } from '../../../../components/table/table-types';

  import type { EntitlementsModel } from '../../../../domains/entitlements/entitlements-model';
  import { buildSafeFileName } from '../../../../../shared/csv';

  export let model: EntitlementsModel,
    groupName = '',
    permissionName = '';

  const { expiredEntitlements, loadingByKey, errors } = model;

  const tableHeaders = [
    { key: 'name', value: 'Feed Name' },
    { key: 'startDate', value: 'Start Date', noWrap: true },
    { key: 'endDate', value: 'End Date', noWrap: true },
    { key: 'expiryDate', value: 'Expiry Date', noWrap: true },
  ] as TableColumn[];

  $: expiredRows = $expiredEntitlements as unknown as DataTableRow[];
  $: csvFilename = buildSafeFileName(groupName, permissionName, 'expired-entitlements');
</script>

<div class="expired-entitlements-table-wrapper">
  <h3 class="section-heading h5">Expired Entitlements</h3>
  {#if $errors.expiredEntitlements}
    <InlineNotification lowContrast hideCloseButton kind="error" subtitle={$errors.expiredEntitlements} />
  {:else}
    <Table
      headers={tableHeaders}
      rows={expiredRows}
      loading={$loadingByKey.expiredEntitlements}
      {csvFilename}
      paginated
      exportable
      searchPlaceholder="Search expired entitlements..."
      emptyText="No expired entitlements."
      size="short"
      routePrefix="expired-entitlements"
    />
  {/if}
</div>

<style>
  .expired-entitlements-table-wrapper :global(tbody td) {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-size: 0.8rem;
  }

  .section-heading {
    margin: 0 0 0.5rem;
  }
</style>
